import React from 'react';
import './ComunicadoBanner.scss';

interface ComunicadoBannerProps {
  titulo: string;
  conteudo: string;
  ilustracao?: string;
  ctaTexto?: string;
  onCtaClick?: () => void;
}

export const ComunicadoBanner: React.FC<ComunicadoBannerProps> = ({
  titulo,
  conteudo,
  ilustracao,
  ctaTexto = "Quero Conhecer",
  onCtaClick
}) => {
  return (
    <div className="comunicado-banner">
      <div className="comunicado-banner__illustration">
        {ilustracao ? (
          <img src={ilustracao} alt="Ilustração" />
        ) : (
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
            <rect x="50" y="60" width="100" height="120" rx="8" fill="#1976D2" opacity="0.2"/>
            <rect x="60" y="70" width="80" height="100" rx="6" fill="#42A5F5"/>
            <circle cx="100" cy="95" r="15" fill="#FDD835"/>
            <path d="M85 120 L100 135 L115 120" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </div>

      <div className="comunicado-banner__content">
        <h2 
          className="comunicado-banner__title"
          dangerouslySetInnerHTML={{ __html: titulo }}
        />
        
        <div 
          className="comunicado-banner__description"
          dangerouslySetInnerHTML={{ __html: conteudo }}
        />

        <button 
          className="comunicado-banner__cta"
          onClick={onCtaClick}
        >
          {ctaTexto}
        </button>
      </div>
    </div>
  );
};
